var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('section',[_c('header',[_c('h2',[_vm._v(_vm._s(_vm._f("t")('Payment Details')))])]),_vm._v(" "),_c('main',[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }